<template>
  <div class="container">
    <section class="section">
      <h1 class="title">Información de la Compañía</h1>
      <div class="field">
        <label class="label">Razon Social</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="company.nombre"
            :class="classform.nombre"
            placeholder="Nombre de la compañía"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Nit o Rut</label>
        <div class="control">
          <input
            v-model="company.nit"
            :class="classform.nit"
            class="input"
            type="text"
            placeholder="Registro único tributario"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Dirección</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="company.direccion"
            :class="classform.direccion"
            placeholder="Dirección"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Teléfono</label>
        <div class="control">
          <input
            class="input"
            v-model="company.telefono"
            :class="classform.telefono"
            type="phone"
            placeholder="Teléfono"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Número de empleados</label>
        <div class="control">
          <input
            v-model="company.numero"
            :class="classform.numero"
            class="input"
            type="number"
            placeholder="Cuantos empleados tiene la compañía"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">Sector Económico</label>
        <div class="control">
          <div class="select is-fullwidth" :class="classform.sector">
            <select v-model="company.sector">
              <option :value="null">Seleccionar</option>
              <option>Sector Agropecuario</option>
              <option>Sector Servicios</option>
              <option>Sector Industrial</option>
              <option>Sector de Transporte</option>
              <option>Sector de Comercio</option>
              <option>Sector Financiero</option>
              <option>Sector de la Construcción</option>
              <option>Sector Minero y Energético</option>
              <option>Sector Comunicaciones</option>
              <option>Sector Educación</option>
              <option>Sector Tecnologías de Información</option>
            </select>
          </div>
        </div>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" @click="saveCompany">Aceptar</button>
        </div>
        <div class="control">
          <button class="button is-light" @click="cancel">Cancelar</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      company: {
        nombre: null,
        nit: null,
        direccion: null,
        telefono: null,
        numero: null,
        sector: null,
      },
      classform: {
        nombre: null,
        nit: null,
        direccion: null,
        telefono: null,
        numero: null,
        sector: null,
      },
    };
  },
  methods: {
    cancel() {
      try {
        this.$router.replace({ name: "clima" });
      } catch (err) {
        console.log(err);
      }
    },
    async saveCompany() {
      try {
        if (!this.company.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe indicar el nombre de la entidad",
            type: "is-warning",
            position: "top-center",
          });
          this.classform.nombre = "is-danger";
          return false;
        } else {
          this.classform.nombre = null;
        }
        if (!this.company.nit) {
          this.$store.dispatch("notify", {
            message: "Debe indicar el nit de la entidad",
            type: "is-warning",
            position: "top-center",
          });
          this.classform.nit = "is-danger";
          return false;
        } else {
          this.classform.nit = null;
        }
        if (!this.company.direccion) {
          this.$store.dispatch("notify", {
            message: "Debe indicar la direccion de la entidad",
            type: "is-warning",
            position: "top-center",
          });
          this.classform.direccion = "is-danger";
          return false;
        } else {
          this.classform.direccion = null;
        }
        if (!this.company.telefono) {
          this.$store.dispatch("notify", {
            message: "Debe indicar el teléfono de la entidad",
            type: "is-warning",
            position: "top-center",
          });
          this.classform.telefono = "is-danger";
          return false;
        } else {
          this.classform.telefono = null;
        }
        if (!this.company.numero) {
          this.$store.dispatch("notify", {
            message: "Indicar cuantos empleados tiene la organización",
            type: "is-warning",
            position: "top-center",
          });
          this.classform.numero = "is-danger";
          return false;
        } else {
          this.classform.numero = null;
        }
        if (!this.company.sector) {
          this.$store.dispatch("notify", {
            message: "Indicar el sector económico de la organización",
            type: "is-warning",
            position: "top-center",
          });
          this.classform.sector = "is-danger";
          return false;
        } else {
          this.classform.sector = null;
        }
        await apiServices.put(`/updatecompany`, this.company);
        const empresa = await apiServices.get(`/empresacredential`);
        this.$store.commit("refreshEmpresa", empresa.data);
        this.$router.replace({ name: "clima" });
      } catch (err) {
        this.$store.dispatch("notify", {
          message: `La empresa ya existe. Debe comunicarse con SIETE para que le asignen esta empresa.`,
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clima/menuclima/Companyinformation.vue